import React, { useEffect, useState, useRef } from "react";
import { Button, Input, Select, Tag, Progress } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils'
import 'braft-editor/dist/index.css';
import 'braft-extensions/dist/code-highlighter.css';
import CodeHighlighter from 'braft-extensions/dist/code-highlighter';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-python';
import Denied from '../../../../images/denied.png';
import PassBox from '../../../Activity/PassBox';
import DeclineBox from '../../../Activity/DeclineBox';
import AddedBox from '../../../Activity/AddedBox';
import MethodSceneBox from './MethodSceneBox';
import instance from "../../../Communal/instance";
import { Alert, srcUrl } from "../../../Communal/utility";
import history from "../../../Communal/history";
import Retrieval from '../../../Activity/retrieval';
import $ from 'jquery'
const { TextArea } = Input;
const { Option } = Select;
const options = {
    syntaxs: [
        {
            name: 'JavaScript',
            syntax: 'javascript'
        }, {
            name: 'HTML',
            syntax: 'html'
        }, {
            name: 'CSS',
            syntax: 'css'
        }, {
            name: 'Java',
            syntax: 'java',
        }, {
            name: 'PHP',
            syntax: 'php'
        }, {
            name: "Python",
            syntax: 'python'
        }
    ],
}
BraftEditor.use(CodeHighlighter(options))

const template = `<h1>手法简述</h1><p style=\"text-indent:2em;\">针对已知的目标名称，收集目标的域名，利用搜索引擎，工具等收集到目标所有的域名信息。</p><p></p><h1>实施条件</h1><p style=\"text-indent:2em;\">已知目标系统名称，例如：四叶草安全。</p><p></p><h1>实施步骤</h1><p style=\"text-indent:2em;\">1、利用搜索引擎搜索目标名称(百度、必应、谷歌)，如下搜索四叶草安全这个几个字，得到www.seclover.com，那么就知道公司主域名是seclover.com。     </p><div class=\"media-wrap image-wrap align-center\" style=\"text-align:center\"><img size=\"2\" _root=\"[object Object]\" src=\"/media/method/image/20191225/image_f0f4d6c1-cb98-46fb-9cf0-02ddfe1af8ee.png\" width=\"700\" height=\"219\" style=\"width:700px;height:219px\"/></div><p></p><div class=\"media-wrap image-wrap align-center\" style=\"text-align:center\"><img size=\"2\" _root=\"[object Object]\" src=\"/media/method/image/20191225/image_ea7cddd7-8e43-4f0f-8fcf-d1ef3a3dd9b4.png\" width=\"721\" height=\"204.11251831054688\" style=\"width:721px;height:204.11251831054688px\"/></div><p></p><p style=\"text-indent:2em;\">2、利用企查查、天眼查等网上公司检索引擎，收集目标名称的域名，这里显示www.seclover.com 是目标名称的官网。     </p><div class=\"media-wrap image-wrap align-center\" style=\"text-align:center\"><img size=\"2\" _root=\"[object Object]\" src=\"/media/method/image/20191225/image_8377a5b1-9f19-4e17-ab4d-5978f3159b5b.png\" width=\"716\" height=\"266.7749938964844\" style=\"width:716px;height:266.7749938964844px\"/></div><p></p><p style=\"text-indent:2em;\">3、找到目标名称主域名，可以用在线子域名查询工具:https://phpinfo.me/domain/，爆破子域名。     </p><div class=\"media-wrap image-wrap align-center\" style=\"text-align:center\"><img size=\"2\" _root=\"[object Object]\" src=\"/media/method/image/20191225/image_27cb3e1a-2e10-4ce8-83f2-5a8cbb6b3c82.png\" width=\"691\" height=\"504\" style=\"width:691px;height:504px\"/></div><p> </p><p style=\"text-indent:2em;\">4、根据主域名，利用谷歌语法，在搜索引擎上搜索目标域名子域名信息。     </p><div class=\"media-wrap image-wrap align-center\" style=\"text-align:center\"><img size=\"2\" _root=\"[object Object]\" src=\"/media/method/image/20191225/image_2d873568-44f9-4226-96f9-3d96b949b1d6.png\" width=\"699\" height=\"236.5749969482422\" style=\"width:699px;height:236.5749969482422px\"/></div><p></p>`;
const MethodForm = ({ param }) => {
    const [type, setType] = useState("0"); //type: 0 添加 1 编辑 2 审核
    const dateRef = useRef();
    const [imagesType, setImagesType] = useState(0);
    const [classify, setClassify] = useState([]);
    const [methodStage, setMethodStage] = useState([]);
    const [selectShow, setSelectShow] = useState(false);
    const [tags, setTags] = useState([]);
    const [inputTags, setInputTags] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [initBox, setInitBox] = useState({
        passBox: false,
        declineBox: false,
        addedBox: false
    });
    const [retrievalBox, setRetrievalBox] = useState({
        show: false,
        type: 0,
        count: 0
    });
    const [submit, setSubmit] = useState({
        name: '',
        back: '',
        detail: BraftEditor.createEditorState(null),
        classify: undefined,
        stage: undefined,
        method_scenes: [],
        tags: [],
        input_tags: [],
        output_tags: [],
        attached: '',
        attached_name: ''
    });
    const [error, setError] = useState({
        name: [],
        back: [],
        detail: [],
        classify: [],
        stage: [],
        tags: [],
        attached: [],
        method_scenes: [],
        input_tags: [],
        output_tags: [],
    })
    const [attachedShow, setAttachedShow] = useState(false)
    const [attachedPercent, setAttachedPercent] = useState(0)
    useEffect(() => {
        setType(param.match.params.type);
        getTag();
        if (param.match.params.id !== '0') {
            getDetail(param.match.params.id)
        } else {
            instance.get("/media/resource/WPTemplate/method/template.json").then(data => {
                submit.detail = BraftEditor.createEditorState(data?.method);
                setSubmit({ ...submit });
            })
        }
        document.getElementsByClassName('submit-ctf')[0].style.minHeight = 'calc(100vh - 40px)';
    }, [param]);
    const getDetail = (id) => {
        instance.get(`/method/${id}/`).then(res => {
            res.detail = BraftEditor.createEditorState(res.detail);
            res.method_scenes = res.method_scenes_list;
            res.tags = res.tags_name;
            res.input_tags = res.input_tags_name;
            res.output_tags = res.output_tags_name;
            setSubmit(res);
        })
    }
    const getTag = () => {
        instance.get('/threat_point/tag/?type=1').then(res => {
            setTags(res)
        })
        instance.get('/threat_point/tag/?type=2').then(res => {
            setInputTags(res)
        })
        instance.get('/ctf/classify/?type=8').then(res => {
            setClassify(res)
        })
        instance.get('/ctf/classify/?type=9').then(res => {
            setMethodStage(res)
        })
    }
    let inputChange = (e, name) => {
        submit[name] = e.target.value;
        setSubmit({ ...submit })
    }
    let handleFouce = (name) => {
        error[name] = []
        setError({ ...error })
    }
    const handleChange = (value, name) => {
        submit[name] = value;
        setSubmit({ ...submit })
    }
    //点击检索按钮进行检索，根据类型判断 检索的字段
    let retrievalClick = (type, text) => {
        if (text.replace(/(^\s*)|(\s*$)/g, "") === "") {
            Alert("warn", "请输入检索内容");
            return
        }
        let list = {
            type: "method",
            flag: text,
            search_type: type
        }
        instance.get("/ctf/search/", { params: list }).then(data => {
            retrievalBox.show = true;
            retrievalBox.count = data.count;
            retrievalBox.type = type;
            setRetrievalBox({ ...retrievalBox })
        })
    }
    let handleEditorChange = (editorState) => {
        submit.detail = editorState;
        setSubmit({ ...submit })
    }
    let myUploadFn = (param) => {
        const fd = new FormData();
        fd.append('image', param.file);
        fd.append("model", "method");
        instance.post("/ctf/upload_image/", fd).then(data => {
            param.success({
                url: data.url,
            })
        })
    }
    //点击上传到媒体库
    let addMediaItem = () => {
        document.getElementsByClassName("images")[0].click();
        document.getElementsByClassName("images")[0].value = "";
        setImagesType(0)

    }
    //点击插入到编辑器
    let insertMediItem = () => {
        document.getElementsByClassName("images")[0].click();
        document.getElementsByClassName("images")[0].value = "";
        setImagesType(1)
    }
    let handleAudit = (data) => {
        if (data.status === 1) {
            if (data.data === "") {
                Alert("error", "请输入奖励奖励数");
                return
            }
        }
        if ((data.status === 2 || data.status === 3) && data.data === "") {
            Alert("error", "请输入审核意见");
            return
        }
        instance.post("/method/" + param.match.params.id + "/audit/", data).then(data => {
            Alert("success", "操作成功");
            initBox.passBox = false;
            initBox.declineBox = false;
            initBox.addedBox = false;
            setInitBox({ ...initBox })
            handleAdd(2, 2)
            // history.push({ pathname: '/resource/methodscene', state: { tabKey: 2 } })
        }).catch(err => {
            Alert("error", err.error)
        })
    }
    let handleAdd = (type, role) => {
        if (srcUrl(submit.detail.toHTML())) {
            Alert('warn', '手法详情中图片存在外部链接，请检查！！！')
            return
        }
        setSubmitLoading(true);
        if (submit.name === '') {
            error.name = ['请输入手法名称']
        }
        if (submit.back === '') {
            error.back = ['请输入手法背景']
        }
        if (submit.tags.length === 0) {
            error.tags = ['请选择手法标签']
        }
        if (submit.method_scenes.length === 0) {
            error.method_scenes = ['请选择手法场景']
        }
        if (!submit.stage) {
            error.stage = ['请选择手法阶段']
        }
        if (!submit.classify) {
            error.classify = ['请选择手法分类']
        }
        if (submit.detail.toHTML() === "<p></p>") {
            Alert("error", "请输入手法详情");
        }
        if (
            submit.name === '' ||
            submit.back === '' ||
            submit.method_scenes.length === 0 ||
            !submit.stage ||
            submit.tags.length === 0 ||
            !submit.classify ||
            submit.detail.toHTML() === "<p></p>"
        ) {
            setError({ ...error });
            setSubmitLoading(false);
            Alert('warn', '提交内容有误，请检查！')
            return
        }
        let arrNew = []
        submit.method_scenes.forEach(item => {
            arrNew.push(item.id)
        })
        let list = {
            name: submit.name,
            back: submit.back,
            classify: submit.classify,
            stage: submit.stage,
            method_scenes: arrNew,
            detail: submit.detail.toHTML(),
            tags: submit.tags,
            input_tags: submit.input_tags,
            output_tags: submit.output_tags,
            attached: submit.attached,
            attached_name: submit.attached_name
        }
        if (attachedShow === true) {
            Alert('warn', '有文件正在上传中，请稍候')
            return
        }
        if (type === 1) {
            instance.post('/method/add/', list).then(res => {
                Alert("success", "提交成功");
                history.push({ pathname: '/resource/methods', state: { tabKey: 2 } })
                setSubmitLoading(false)
            }).catch(err => {
                setSubmitLoading(false);
                errorInfo(err);
            })
        } else if (type === 2) {
            instance.patch(`/method/${param.match.params.id}/`, list).then(res => {
                if (role === 1) {
                    Alert("success", "修改成功");
                } else if (role === 2) {
                    // Alert("success","修改成功");
                } else {
                    Alert("success", "提交成功");
                    history.push({ pathname: '/resource/methods', state: { tabKey: 2 } });
                }
                setSubmitLoading(false)
            }).catch(err => {
                setSubmitLoading(false);
                errorInfo(err);
            })
        }
    }
    const errorInfo = (err) => {
        if (err.error) {
            Alert('error', err.error)
        }
        if (err.name) {
            error.name = err.name
        }
        if (err.detail) {
            Alert('error', err.detail)
        }
        if (err.classify) {
            error.classify = err.classify
        }
        if (err.tags) {
            error.tags = err.tags
        }
        if (err.back) {
            error.back = err.back
        }
        if (err.stage) {
            error.stage = err.stage
        }
        if (err.method_scenes) {
            error.method_scenes = err.method_scenes
        }
        if (err.input_tags) {
            error.input_tags = err.input_tags
        }
        if (err.output_tags) {
            error.output_tags = err.output_tags
        }
        if (err.attached) {
            error.attached = err.attached
        }
        if (err.attached_name) {
            error.attached = err.attached_name
        }
        Alert('warn', '提交内容有误，请检查！')
        setError({ ...error })
    }
    let uploadChange = () => {
        if (attachedShow === true) {
            Alert('warn', '有文件正在上传中，请稍候')
            return
        }
        document.getElementsByClassName("upload-file-one")[0].click();
        document.getElementsByClassName("upload-file-one")[0].value = "";
        submit.attached = '';
        submit.attached_name = '';
        error.attached = [];
        setSubmit({ ...submit })
        setError({ ...error })
    }
    let changeFile = () => {
        let file = document.getElementsByClassName("upload-file-one")[0].files[0];
        if (file !== undefined) {
            if (file.size > 1024 * 1024 * 500) {
                Alert("error", "上传附件不能大于500M");
                return
            }
            let form = document.getElementById('formImg1');
            let formdData = new FormData(form);
            formdData.append("model", "method")
            setAttachedShow(true)
            $.ajax({
                url: "/ctf/upload_file/",
                type: "POST",
                data: formdData,
                contentType: false,
                processData: false,
                xhr: () => {
                    var myXhr = $.ajaxSettings.xhr()
                    if (myXhr.upload) { // check if upload property exists 
                        myXhr.upload.addEventListener('progress', (e) => {
                            var loaded = e.loaded;//已经上传大小情况
                            var tot = e.total;//附件总大小
                            var per = Math.floor(100 * loaded / tot);  //已经上传的百分比
                            setAttachedPercent(per)
                            if (myXhr.readyState === 1 && per === 100) {
                                setAttachedPercent(99)
                            }
                        }, false);
                    }
                    return myXhr;
                },
                success: (data) => {
                    setAttachedShow(false)
                    setAttachedPercent(0)
                    submit.attached_name = data.origin_file_name;
                    submit.attached = data.url
                    setSubmit({ ...submit })
                },
                error: (err) => {
                    if (err.file) {
                        error.attached = err.file;
                    }
                    if (err.non_field_errors) {
                        error.attached = err.non_field_errors;
                    }
                    setError({ ...error })
                }
            })
        }
    }
    //点击上传文件
    let changeImage = () => {
        let file = document.getElementsByClassName("images")[0].files[0];
        if (file !== undefined) {
            if (file.size > 5 * 1024 * 1024) {
                Alert("error", "上传图片不能大于5M")
                return
            }
            let form = document.getElementById('file-image');
            let formdData = new FormData(form);
            formdData.append("model", "method");
            instance.post("/ctf/upload_image/", formdData).then(data => {
                if (imagesType === 0) {
                    if (dateRef.current !== undefined) {
                        let braftFinder = dateRef.current.getFinderInstance();
                        braftFinder.addItems([
                            {
                                id: new Date().getTime(),
                                type: 'IMAGE',
                                url: data.url
                            }
                        ])
                    }
                } else if (imagesType === 1) {
                    let editorState = ContentUtils.insertMedias(submit.detail, [
                        {
                            type: 'IMAGE',
                            url: data.url
                        }
                    ])
                    submit.detail = editorState;
                    setSubmit({ ...submit })
                }
                Alert("success", "上传成功")
            }).catch(err => {
                if (err.image) {
                    Alert("error", err.image)
                }
            })
        }
    }
    const handleDeleteTag = (key) => {
        submit.method_scenes.splice(key, 1);
        setSubmit({ ...submit })
    }
    return (
        <div className="submit-ctf">
            <div className="banner"></div>
            <div className="content-container">
                <div className="submit-ctf-div submit-ctf-name">
                    {
                        type === "0" && "提交手法"
                    }
                    {
                        type === "1" && "编辑手法"
                    }
                    {
                        type === "2" && "审核手法"
                    }
                    {
                        submit.status === 3 &&
                        <div className="status">
                            <img src={Denied} alt="" />
                        </div>
                    }
                </div>
                {
                    submit.is_show_opin && submit.opin && submit.opin.length > 0 &&
                    <div className="submit-ctf-div audit-opinion">
                        <div className="title" style={{ borderBottom: "1px solid #f4f4f4" }}>审核意见</div>
                        <div className="content">
                            <div>
                                {
                                    submit.opin &&
                                    submit.opin.map((val, key) => {
                                        return <div key={key + "key"}>
                                            <div className="time">[{val.time}]</div>
                                            <div className="details">{val.msg}</div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                <div className="submit-ctf-div subject-info">
                    <div className="title">
                        手法信息
                    </div>
                    <div className="content">
                        <div className="retrieval-div">
                            <span><b>*</b>手法名称</span>
                            <Input
                                value={submit.name}
                                className="content-input"
                                placeholder="请输入手法名称"
                                onChange={(e) => inputChange(e, "name")}
                                maxLength="50"
                                onFocus={() => handleFouce("name")}
                            />
                            <span className="number">{50 - submit.name.length}</span>
                            <Button type="primary" onClick={() => retrievalClick(1, submit.name)}>检索</Button>
                            <div className="error-message">{error.name[0]}</div>
                        </div>
                        <div className="retrieval-div">
                            <span><b>*</b>手法背景</span>
                            <TextArea
                                value={submit.back}
                                className="content-input"
                                placeholder="请输入手法背景"
                                onChange={(e) => inputChange(e, "back")}
                                // autoSize
                                maxLength="180"
                                onFocus={() => handleFouce("back")}
                            />
                            <span className="number">{180 - submit.back.length}</span>
                            <Button type="primary" onClick={() => retrievalClick(2, submit.back)}>检索</Button>
                            <div className="error-message">{error.back[0]}</div>
                        </div>
                        <div className='methods-scene-tags'>
                            <span><b>*</b>手法场景</span>
                            <div>
                                <span style={{ display: 'inline-block', width: '20px' }}></span>
                                {/* 占位符 */}
                                <span
                                    onClick={() => {
                                        error.method_scenes = [];
                                        setError({ ...error })
                                        setSelectShow(true)
                                    }}
                                >
                                    选择
                                </span>
                                {/* 请<span>选择</span>添加手法场景 */}
                                <div className='tags-show'>
                                    {
                                        submit.method_scenes.map((val, key) => {
                                            return <Tag
                                                closable
                                                key={key}
                                                style={{ padding: '3px 10px', borderRadius: '3px' }}
                                                onClose={e => {
                                                    e.preventDefault();
                                                    handleDeleteTag(key)
                                                }}
                                            >
                                                {val.name}
                                            </Tag>
                                        })
                                    }
                                </div>
                            </div>
                            {
                                error.method_scenes.length > 0 &&
                                <p className="error-message">{error.method_scenes[0]}</p>
                            }
                        </div>
                        <div>
                            <span><b>*</b>手法分类</span>
                            <Select
                                value={submit.classify}
                                placeholder='请选择手法分类'
                                style={{ width: 180 }}
                                onChange={(value) => handleChange(value, 'classify')}
                                onClick={() => handleFouce("classify")}
                            >
                                {
                                    classify.map((val, key) => {
                                        return <Option
                                            key={key}
                                            value={val.id}
                                        >
                                            {val.name}
                                        </Option>
                                    })
                                }
                            </Select>
                            <div className="error-message">{error.classify[0]}</div>
                        </div>
                        <div>
                            <span><b>*</b>手法阶段</span>
                            <Select
                                value={submit.stage}
                                placeholder='请选择手法阶段'
                                style={{ width: 180 }}
                                onChange={(value) => handleChange(value, 'stage')}
                                onClick={() => handleFouce("stage")}
                            >
                                {
                                    methodStage.map((val, key) => {
                                        return <Option
                                            key={key}
                                            value={val.id}
                                        >
                                            {val.name}
                                        </Option>
                                    })
                                }

                            </Select>
                            <div className="error-message">{error.stage[0]}</div>
                        </div>
                    </div>
                </div>
                <div className="submit-ctf-div topic-answer">
                    <div className="title">
                        手法详情
                    </div>
                    <div>
                        <span><b>*</b>手法详情</span>
                        <div className="my-component">
                            <BraftEditor
                                value={submit.detail}
                                onChange={handleEditorChange}
                                ref={dateRef}
                                media={{
                                    uploadFn: myUploadFn,
                                    image: false
                                }}
                                excludeControls={["superscript", "subscript", "emoji", "remove-styles"]}
                                extendControls={[
                                    'separator',
                                    {
                                        key: 'add-media',
                                        type: 'button',
                                        text: '插入图片到媒体库',
                                        onClick: () => addMediaItem()
                                    },
                                    {
                                        key: 'insert-media',
                                        type: 'button',
                                        text: '插入图片到编辑器',
                                        onClick: () => insertMediItem()
                                    }
                                ]}
                            />
                            <div className="error-message" >{error.detail[0]}</div>
                        </div>
                    </div>
                </div>
                <div className='submit-ctf-div subject-info'>
                    <div className="title">
                        添加标签
                    </div>
                    <div className="content">
                        <div className='menthod-tag'>
                            <span><b>*</b>手法标签</span>
                            <Select
                                mode="tags"
                                style={{ width: '500px' }}
                                placeholder="请选择手法标签"
                                value={submit.tags}
                                onChange={(value => handleChange(value, 'tags'))}
                                onClick={() => handleFouce("tags")}
                            >
                                {
                                    tags.map((val, key) => {
                                        return <Option value={val.name} key={key}>
                                            {val.name}
                                        </Option>
                                    })
                                }
                            </Select>
                            <div className='reminder'>手法标签是指在使用该手法中涉及的对象、漏洞、应用、工具等的关键字</div>
                            <div className="error-message" >{error.tags[0]}</div>
                        </div>
                        <div className='menthod-tag'>
                            <span>输入标签</span>
                            <Select
                                mode="tags"
                                style={{ width: '500px' }}
                                placeholder="请选择输入标签"
                                value={submit.input_tags}
                                onChange={(value => handleChange(value, 'input_tags'))}
                                onClick={() => handleFouce("input_tags")}
                            >
                                {
                                    inputTags.map((val, key) => {
                                        return <Option value={val.name} key={key}>
                                            {val.name}
                                        </Option>
                                    })
                                }
                            </Select>
                            <div className='reminder'>手法输入标签是指在使用该手法时需要输入的前置条件的关键字</div>
                            <div className="error-message" >{error.input_tags[0]}</div>
                        </div>
                        <div className='menthod-tag'>
                            <span>输出标签</span>
                            <Select
                                mode="tags"
                                style={{ width: '500px' }}
                                placeholder="请选择输出标签"
                                value={submit.output_tags}
                                onChange={(value => handleChange(value, 'output_tags'))}
                                onClick={() => handleFouce("output_tags")}
                            >
                                {
                                    inputTags.map((val, key) => {
                                        return <Option value={val.name} key={key}>
                                            {val.name}
                                        </Option>
                                    })
                                }
                            </Select>
                            <div className='reminder'>手法输出标签是指在使用该手法后会输出的数据或者结果的关键字</div>
                            <div className="error-message" >{error.output_tags[0]}</div>
                        </div>
                    </div>
                </div>
                <div className='submit-ctf-div subject-upload subject-info'>
                    <div className="title">
                        上传附件
                    </div>
                    <div className="content">
                        <div className="upload-tool-div">
                            <span>手法附件</span>
                            <form id="formImg1">
                                <div>
                                    <span className="upload" onClick={uploadChange}>
                                        选择
                                        <input
                                            type="file"
                                            name="file"
                                            className="upload-file-one"
                                            accept=".zip,.rar"
                                            onChange={changeFile}
                                        />
                                    </span>
                                    （ZIP/RAR，500M以内）
                                    {
                                        submit.attached !== "" && [
                                            <span className="file-name" key="1">
                                                <a href={submit.attached} download>
                                                    <PaperClipOutlined />
                                                    {submit.attached_name}
                                                </a>
                                            </span>,
                                            <Button type="link" key="2" danger onClick={() => {
                                                submit.attached_name = "";
                                                submit.attached = "";
                                                setSubmit({ ...submit })
                                            }}>删除</Button>
                                        ]
                                    }
                                    {
                                        attachedShow &&
                                        <>
                                            <Progress percent={attachedPercent} />
                                            <span> （上传中，请稍候）</span>
                                        </>
                                    }
                                </div>
                            </form>
                            <div className="error-message" >{error.attached[0]}</div>
                        </div>
                    </div>
                </div>
                {
                    //新增
                    type === "0" &&
                    <div className="submit-btn">
                        <Button type="primary" loading={submitLoading} onClick={() => handleAdd(1)}>提交</Button>
                    </div>
                }
                {
                    //编辑
                    type === "1" &&
                    <div className="submit-btn">
                        <Button type="primary" loading={submitLoading} onClick={() => handleAdd(2)}>提交</Button>
                    </div>
                }
                {
                    type === "2" &&
                    <div className="submit-btn">
                        <Button
                            type="primary"
                            onClick={() => {
                                initBox.passBox = true;
                                setInitBox({ ...initBox })
                            }}
                        >
                            通过
                        </Button>
                        <Button
                            style={{ backgroundColor: "transparent", color: "#266cff" }}
                            type="primary"
                            onClick={() => history.push({ pathname: '/resource/methods', state: { tabKey: 2 } })}
                        >
                            取消
                        </Button>
                        <Button className="modify" loading={submitLoading} onClick={() => handleAdd(2, 1)}>保存修改</Button>
                        <Button
                            className="decline"
                            onClick={() => {
                                initBox.declineBox = true;
                                setInitBox({ ...initBox })
                            }}
                        >
                            拒绝
                        </Button>
                        <Button
                            className="added"
                            onClick={() => {
                                initBox.addedBox = true;
                                setInitBox({ ...initBox })
                            }}
                        >
                            待补充
                        </Button>
                        <Button
                            className="added"
                            onClick={() => handleAudit({ status: 0 })}
                        >
                            待审核
                        </Button>
                    </div>
                }
            </div>
            <form id="file-image">
                <input
                    type="file"
                    name="image"
                    accept=".jpg,.png,.gif"
                    style={{ display: "none" }}
                    className="images"
                    onChange={changeImage}
                />
            </form>
            {
                initBox.passBox &&
                <PassBox
                    close={() => {
                        initBox.passBox = false;
                        setInitBox({ ...initBox })
                    }}
                    click={handleAudit}
                />
            }
            {
                initBox.declineBox &&
                <DeclineBox
                    close={() => {
                        initBox.declineBox = false;
                        setInitBox({ ...initBox })
                    }}
                    click={handleAudit}
                />
            }
            {
                initBox.addedBox &&
                <AddedBox
                    close={() => {
                        initBox.addedBox = false;
                        setInitBox({ ...initBox })
                    }}
                    click={handleAudit}
                />
            }
            {
                retrievalBox.show &&
                <Retrieval
                    close={() => {
                        retrievalBox.show = false;
                        setRetrievalBox({ ...retrievalBox })
                    }}
                    count={retrievalBox.count}
                    name={
                        {
                            1: "手法名称",
                            2: '手法背景'
                        }[retrievalBox.type]
                    }
                />
            }
            {
                selectShow &&
                <MethodSceneBox
                    onClose={() => setSelectShow(false)}
                    method_scene={submit.method_scenes}
                    onEnter={(data) => {
                        submit.method_scenes = data;
                        setSubmit({ ...submit });
                        setSelectShow(false);
                    }}
                />
            }
        </div>
    )
}
export default MethodForm;